export default __webpack_public_path__ + "static/media/img_at_location.1cde75f2.png";